import { Box, Chip, CollapsibleCard } from '@atgfr8/atg-ui-tailwind';
import { SelectInputCustom } from '@components/Select';
import {
  customerDetailsStore,
  DocumentDetails,
  fetchCustomerDocumentType,
  updateCustomerDetailsState,
} from '@store/customers/customerDetails';
import { size } from 'lodash';
import { createSignal, onMount } from 'solid-js';

type MenuItemType = {
  label: string;
  value: string | number;
  disabled?: boolean;
};

const RequiredDocumentType = () => {
  const [documentType, setDocumentType] = createSignal<DocumentDetails[]>([]);
  const [documentList, setDocumentList] = createSignal<MenuItemType[]>([]);

  onMount(async () => {
    const response = await fetchCustomerDocumentType();
    if (response && size(response.value) > 0) {
      setDocumentType(response.value);
      const filteredResponse = response.value.filter(
        (item) =>
          !customerDetailsStore.customer.requiredDocumentTypes.some(
            (doc) => doc.documentKey === item.documentKey,
          ),
      );
      setDocumentList(
        filteredResponse.map((item) => ({
          label: item.documentKey,
          value: item.documentKey,
        })),
      );
    }
  });

  const handleDelete = (value: string) => {
    const updatedRequiredDocs =
      customerDetailsStore.customer.requiredDocumentTypes.filter(
        (item) => item.documentKey !== value,
      );
    const restoredDocument = documentType().find(
      (item) => item.documentKey === value,
    );
    if (restoredDocument) {
      setDocumentList([
        ...documentList(),
        {
          label: restoredDocument.documentKey,
          value: restoredDocument.documentKey,
        },
      ]);
    }
    updateCustomerDetailsState({
      requiredDocumentTypes: updatedRequiredDocs,
    });
  };

  const handleChange = (value: string) => {
    const selectedDocument = documentType().find(
      (item) => item.documentKey === value,
    );
    if (!selectedDocument) return;
    const updatedDocumentList = documentList().filter(
      (item) => item.value !== value,
    );
    setDocumentList(updatedDocumentList);
    updateCustomerDetailsState({
      requiredDocumentTypes: [
        ...customerDetailsStore.customer.requiredDocumentTypes,
        selectedDocument,
      ],
    });
  };

  return (
    <CollapsibleCard startTitle="Required Documents Type" class="mb-2">
      <Box>
        <SelectInputCustom
          dataTestId="required-document-type-search"
          multiple
          menuItems={documentList().map((item) => ({
            label: item.label,
            value: item.value as string,
          }))}
          value={customerDetailsStore.customer.requiredDocumentTypes.map(
            (i) => i.documentKey,
          )}
          renderValue={(selected) => {
            const values = Array.isArray(selected) ? selected : [selected];
            return (
              <Box
                style={{
                  display: 'flex',
                  'flex-wrap': 'wrap',
                }}
                gap={0.5}
              >
                {values.map((value) => (
                  <Chip
                    id={`chip-doc-${value}`}
                    text={value}
                    variant="filled"
                    isDeleteIcon
                    deleteIconColor="white"
                    class="text-white! bg-[#026EA1]! rounded"
                    onDelete={() => handleDelete(value)}
                  />
                ))}
              </Box>
            );
          }}
          label=""
          onChange={handleChange}
        />
      </Box>
    </CollapsibleCard>
  );
};

export default RequiredDocumentType;
